const callIntercom = (method: string, ...args: unknown[]) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.Intercom !== 'function') {
    return;
  }

  (window.Intercom as (...params: unknown[]) => void)(method, ...args);
};

export const boot = (options = {}) => {
  callIntercom('boot', {
    api_base: 'https://api-iam.intercom.io',
    app_id: process.env.INTERCOM_APP_ID,
    custom_launcher_selector: '#intercom-launcher',
    hide_default_launcher: true,
    ...options,
  });
};

export const update = (options = {}) => {
  callIntercom('update', {
    ...options,
  });
};

export const show = () => {
  callIntercom('show');
};

export const showSpace = (space: string) => {
  callIntercom('showSpace', space);
};

export const startSurvey = (id: number) => {
  callIntercom('startSurvey', id);
};

export const showNewMessage = (message: string) => {
  callIntercom('showNewMessage', message);
};

export const showArticle = (articleId: number) => {
  callIntercom('showArticle', articleId);
};

export const shutdown = () => {
  callIntercom('shutdown');
};
